import { useState, useCallback, memo } from "react";
import { CheckCircleOutline } from "@mui/icons-material";
import { ListItem, ListItemIcon, ListItemText, Switch, Box, Fade } from "@mui/material";

import { TaskNoteBubble } from "./TaskNoteBubble";
import { colors } from "../../../../../../../../../ui/colors";
import { SASSwitchStyles } from "../../../../../../../../../ui/styles/inputStyles";

const TaskSwitchComponent = ({ task, checked, disabled, quantity, onToggle, areaUid }) => {
  const [hover, setHover] = useState(false);

  const handleToggle = useCallback(() => {
    if (disabled) return;
    onToggle?.();
  }, [disabled, onToggle]);

  const taskId = String(task?.uid ?? task?.id);
  const noteFromStore = String(task?.note ?? "");
  const hasNote = noteFromStore.trim().length > 0;

  return (
    <ListItem
      sx={{
        p: 1,
        position: "relative",
        "&:hover": {
          backgroundColor: "rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.02)",
        },
      }}
      disableGutters
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {quantity > 0 && checked && (hasNote || hover) && (
        <Fade in={hasNote || hover}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              right: 36,
              transform: "translateY(-50%)",
              zIndex: 9999,
            }}
            onClick={(event) => event.stopPropagation()}
          >
            <TaskNoteBubble areaUid={areaUid} taskId={taskId} taskName={task?.name} noteFromStore={noteFromStore} />
          </Box>
        </Fade>
      )}

      <ListItemIcon sx={{ minWidth: 32 }}>
        <CheckCircleOutline
          fontSize="small"
          sx={{
            color: checked ? colors.orange.base : colors.gray[300],
          }}
        />
      </ListItemIcon>

      <ListItemText
        primaryTypographyProps={{
          variant: "body2",
          color: colors.gray[600],
        }}
        primary={task?.name}
      />

      <Switch sx={{ ...SASSwitchStyles }} edge="end" size="small" checked={checked} disabled={disabled} onChange={handleToggle} />
    </ListItem>
  );
};

export const TaskSwitch = memo(TaskSwitchComponent);
